<template>
  <div class="d-flex align-items-center min-vh-100">
    <CContainer fluid>
      <CRow class="justify-content-center">
        <CCol md="6">
          <CCard class="mx-4 mb-0">
            <CCardBody class="p-4">
              <CForm @submit="onSubmit">
                <h1>Registration</h1>
                <p class="text-muted">Create your account</p>
                <b-form-group>
                  <label>Company name</label>
                  <b-input placeholder="Company name" v-model="item.name"
                           :class="{'is-invalid': $v.item.name.$error}"></b-input>
                  <b-form-invalid-feedback>Enter company name</b-form-invalid-feedback>
                </b-form-group>
                <div class="row">
                  <div class="col">
                    <b-form-group>
                      <label>Address</label>
                      <b-input placeholder="Address" v-model="item.address1"
                               :class="{'is-invalid': $v.item.address1.$error}"></b-input>
                      <b-form-invalid-feedback>Enter an address</b-form-invalid-feedback>
                    </b-form-group>
                  </div>
                  <div class="col">
                    <b-form-group>
                      <label>Apartment, suite, etc.</label>
                      <b-input placeholder="Apartment, suite, etc" v-model="item.address2"></b-input>
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <b-form-group>
                      <label>City</label>
                      <b-input placeholder="City" :class="{'is-invalid': $v.item.city.$error}" v-model="item.city"></b-input>
                      <b-form-invalid-feedback>Enter a city</b-form-invalid-feedback>
                    </b-form-group>
                  </div>
                  <div class="col">
                    <b-form-group>
                      <label>State</label>
                      <b-form-select v-model="item.stateCode" :class="{'is-invalid': $v.item.stateCode.$error}" :plain="true">
                        <option value=''>Select a state</option>
                        <option v-for="(state, i) in states" :value="state.value" :key="i">
                          {{ state.text }}
                        </option>
                      </b-form-select>
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <b-form-group>
                      <label>Zip code</label>
                      <b-input placeholder="Zip code" :class="{'is-invalid': $v.item.zipCode.$error}"
                               v-model="item.zipCode"></b-input>
                      <b-form-invalid-feedback>Enter a zip code</b-form-invalid-feedback>
                    </b-form-group>
                  </div>
                  <div class="col">
                    <label>Phone</label>
                    <CInput type="tel" maxlength="14" v-model="item.phone" @input="acceptNumber"
                            :addInputClasses="{'is-invalid': $v.item.phone.$error}"
                            placeholder="(123) 345-6789"
                            :invalid-feedback="getPhoneInvalidMessage">
                      <template #prepend-content>
                        <CIcon name="cil-phone"/>
                      </template>
                    </CInput>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label>Email</label>
                    <CInput v-model="item.email" :addInputClasses="{'is-invalid': $v.item.email.$error}"
                            placeholder="Email"
                            autocomplete="email"
                            prepend="@"
                            :invalid-feedback="getEmailInvalidMessage"/>
                  </div>
                  <div class="col">
                    <label>Password</label>
                    <CInput v-model="item.password" :addInputClasses="{'is-invalid': $v.item.password.$error}"
                            placeholder="Password"
                            type="password"
                            autocomplete="new-password"
                            :invalid-feedback="getPasswordInvalidMessage">
                      <template #prepend-content>
                        <CIcon name="cil-lock-locked"/>
                      </template>
                    </CInput>
                  </div>
                </div>
                <CButton type="submit" color="success" block>Create Account</CButton>
                <router-link class="center btn btn-link" to="/login">Log in</router-link>
              </CForm>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
import { required, minLength, email } from 'vuelidate/lib/validators'
import { STATES } from '@/components/helper/states'
export default {
  name: 'Register',
  data () {
    return {
      states: STATES,
      item: {
        name: '',
        address1: '',
        address2: '',
        city: '',
        stateCode: '',
        zipCode: '',
        phone: '',
        email: '',
        password: ''
      },
      time: null,
      // eslint-disable-next-line no-useless-escape
      email_regex: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
    }
  },
  created () {
    this.$loading.hide()
  },
  methods: {
    onSubmit (event) {
      event.preventDefault()
      this.item.phone = this.item.phone.replace(/\D/g, '')
      if (this.$v.item.$invalid) {
        this.$v.$touch()
        return
      }
      if (!this.isValidZipCode(this.item.zipCode)) {
        this.$toastr.error('Enter a valid zip code')
        return
      }
      this.$loading.show()
      this.axios.post('register', this.item)
        .then(response => {
          this.$loading.hide()
          if (response.status === 200) {
            this.$toastr.success('Successfully registered!')
            this.$router.push('/registration-completed')
          } else {
            this.$toastr.error(response.data.message)
          }
        }).catch((error) => {
          if (error.response && error.response.data.message) {
            this.$toastr.error(error.response.data.message)
          }
          this.$loading.hide()
        })
    },
    acceptNumber (value) {
      const x = value
        .replace(/\D/g, '')
        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/)

      value = !x[2]
        ? x[1]
        : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '')
      this.item.phone = value
    },
    isValidZipCode (value) {
      return /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(value)
    }
  },
  computed: {
    getEmailInvalidMessage: function () {
      if (this.item.email && !this.$v.item.email.email) {
        return 'Enter a valid email address'
      } else {
        return 'Enter your email'
      }
    },
    getPhoneInvalidMessage: function () {
      if (this.item.phone && !this.$v.item.phone.length) {
        return 'Enter a valid phone number'
      }
      return 'Enter a phone number'
    },
    getPasswordInvalidMessage: function () {
      if (this.item.password && !this.$v.item.password.minLength) {
        return 'Password must be minimum 6 characters'
      } else {
        return 'Enter a password'
      }
    }
  },
  validations: {
    item: {
      name: {
        required
      },
      address1: {
        required
      },
      city: {
        required
      },
      stateCode: {
        required
      },
      zipCode: {
        required
      },
      phone: {
        required, minLength: minLength(10)
      },
      email: {
        required, email
      },
      password: {
        required, minLength: minLength(6)
      }
    }
  }
}
</script>
